export default __webpack_public_path__ + "static/media/goodreads_scraping.687a5c6f.gif";